module.exports = __webpack_public_path__ + "public/images/program/program-11.16aa61fba8a164aa045872d82895b18b.jpg";